import { useSelector } from "react-redux";

import { useIsLeadsCriticalDataLoading } from "app/pages/sales-intelligence/modules/leads-search/hooks/useIsLeadsCriticalDataLoading";
import { selectIsContactsSearchDtoReady } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import { selectIsContactsVisible } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

export const useIsContactsDataAvailable = () => {
    const isContactsSearchDtoReady = useSelector(selectIsContactsSearchDtoReady);
    const isContactsVisible = useSelector(selectIsContactsVisible);

    const isLeadsCriticalDataLoading = useIsLeadsCriticalDataLoading();

    return isContactsVisible && !isLeadsCriticalDataLoading && isContactsSearchDtoReady;
};
